<template>
    <div class="page-container">
        <div class="page-title">请选择提货商品</div>
        <div class="list">
            <div class="incentive-item" v-for="(item,index) in goodsList" :key="index">
                <div class="goods-info-block">
                    <img :src="item.picUrl" class="goods-pic">
                    <div class="goods-detail">
                        <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                        <div class="goods-sku">
                            <select class="sku-select" @change="changeSku(index)" v-model="item.skuValue">
                                <option value="xiang">整箱(6瓶)</option>
                                <option value="ping">单瓶</option>
                            </select>
                            <van-stepper v-model="item.number" :max="item.maxNum" min="0" button-size="22" />
                        </div>
                        <div class="caigou-price">采购价：¥{{item.price}}/瓶</div>
                    </div>
                </div>
                <div class="item-bottom">
                    <div class="count-notice">(当前库存：{{item.inventory}}瓶)</div>
                </div>
            </div>
        </div>
        <div class="notice-block">
            <div class="notice-title">关于运费问题</div>
            <div class="notice-content">您所提货的酒我司将为您承担5元/瓶运费,当运费高于我方承担的时候,将从您的御粮账户中直接扣减不足的运费金额.</div>
        </div>
        <!-- <div class="bottom-notice">请至少选择1瓶提货</div> -->
        <div class="btn-confirm" @click="jumpConfirm">提交订单</div>
    </div>
</template>
<script>
import { Stepper,Toast } from 'vant'

import $http from '@/lib/request'
import config from '@/config'

export default {
    data(){
        return {
            goodsList:[],//商品列表
            totalCount:0,//一共选择的商品总数
        }
    },
    components:{
        [Stepper.name]:Stepper,
        [Toast.name]:Toast
    },
    activated(){
        $http({
            method:'post',
            url:config.api.pickupGoods
        }).then(res=>{
            if(res.errno == 0){
                let tmp=res.data;
                for(let i=0,len=tmp.length;i<len;i++){
                    // 初始化skuvalue
                    tmp[i].skuValue = 'xiang';
                    tmp[i].number =  0;
                    tmp[i].maxNum = Math.floor(tmp[i].inventory / 6);
                }

                this.goodsList=tmp;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    deactivated(){
        this.goodsList=[];
    },
    methods:{
        jumpConfirm(){
            let list = this.goodsList;
            let tmpList=[];
            for(let i=0;i<list.length;i++){
                this.totalCount+=list[i].number;
                if(list[i].number != 0){
                    tmpList.push(list[i]);
                }
            }
            if(this.totalCount <= 0){
                Toast('请至少选择1瓶提货');
                return;
            }

            this.$store.commit('setPickupGoodsInfo',tmpList);

            this.$router.push({
                name:'pickup'
            });
        },
        changeSku(index){
            let tmp=this.goodsList;
            if(tmp[index].skuValue == 'xiang'){
                tmp[index].maxNum = Math.floor(tmp[index].inventory / 6)
            }else{
                tmp[index].maxNum = tmp[index].inventory;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.page-container{
    background:#f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
    padding:10px;
    padding-bottom: 100px;
    .page-title{
        font-size: 16px;
        color:#333;
        line-height: 22px;
        margin-bottom: 10px;
    }
    .list{
        .incentive-item{
            background:#fff;
            border-radius: 4px;
            padding:0 15px 15px;
            margin-bottom: 10px;
            .goods-info-block{
                display: flex;
                justify-content: flex-start;
                padding-top:15px;
                .goods-pic{
                    width:80px;
                    height:80px;
                    border-radius: 4px;
                    margin-right: 10px;
                }
                .goods-detail{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width:calc(100% - 70px);
                    .goods-name{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color:#000;
                        line-height: 20px;
                        font-size: 14px;
                    }
                    .goods-sku{
                        @include flex-between();
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                        .sku-select{
                            border:none;
                            height:20px;
                            background:#f6f6f6;
                            border-radius: 26px;
                            font-size: 12px;
                            color:#999;
                            padding:0 6px;
                        }
                    }
                    .caigou-price{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
            .item-bottom{
                .count-notice{
                    font-size: 10px;
                    color:#E01919;
                    line-height: 14px;
                    margin-top: 5px;
                    margin-left:90px;
                }
            }
        }
    }
    .notice-block{
        background:#fff;
        border-radius: 4px;
        padding:15px;
        .notice-title{
            color:#333;
            line-height: 20px;
            font-size: 14px;
            margin-bottom: 14px;
        }
        .notice-content{
            font-size: 12px;
            color:#999;
            line-height: 18px;
        }
    }
    .bottom-notice{
        font-size: 12px;
        color:#E43D3D;
        margin-top: 30px;
        text-align: center;
    }
    .btn-confirm{
        position: fixed;
        left: 50%;
        transform: translateX(-50%);
        bottom:20px;
        width: 180px;
        height: 40px;
        line-height: 40px;
        border-radius: 26px;
        text-align: center;
        font-size: 16px;
        color:#fff;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        &.disabled{
            color:#999;
            background: #DCDCDC;
        }
    }
}
</style>